import { loginTypes } from "redux/reducers/login/loginTypes";
import { THEME_MODES, readThemeMode, persistThemeMode } from "helpers/themeMode";

const SET_COLOR = "SET_COLOR";
const SET_COLOR_SIDEBAR = "SET_COLOR_SIDEBAR";
const SET_IS_MINIMIZED = "SET_IS_MINIMIZED";
const SET_IS_IMAGE = "SET_IS_IMAGE";
const SET_IMAGE = "SET_IMAGE";
const SET_THEME_MODE = "SET_THEME_MODE";

const { CLOSE_SESSION_LOGIN } = loginTypes;

const INITIAL_STATE = {
  colorBg: "blue",
  colorSidebar: "black",
  isMinimized: false,
  isImage: true,
  image: "",
  themeMode: readThemeMode(),
};

const configReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_COLOR:
      return {
        ...state,
        colorBg: payload,
      };
    case SET_COLOR_SIDEBAR:
      return {
        ...state,
        colorSidebar: payload,
      };
    case SET_IS_MINIMIZED:
      return {
        ...state,
        isMinimized: payload,
      };
    case SET_IS_IMAGE:
      return {
        ...state,
        isImage: payload,
      };
    case SET_IMAGE:
      return {
        ...state,
        image: payload,
      };
    case SET_THEME_MODE:
      return {
        ...state,
        themeMode: payload,
      };
    case CLOSE_SESSION_LOGIN:
      return {
        ...INITIAL_STATE,
        themeMode: readThemeMode(),
      };
    default:
      return state;
  }
};

const setColor = (color) => {
  return {
    type: SET_COLOR,
    payload: color,
  };
};

const setColorSidebar = (color) => {
  return {
    type: SET_COLOR_SIDEBAR,
    payload: color,
  };
};

const setIsMinimized = (value) => {
  return {
    type: SET_IS_MINIMIZED,
    payload: value,
  };
};
const setIsImage = (value) => {
  return {
    type: SET_IS_IMAGE,
    payload: value,
  };
};
const setImage = (image) => {
  return {
    type: SET_IMAGE,
    payload: image,
  };
};

const setThemeMode = (mode) => {
  return {
    type: SET_THEME_MODE,
    payload: mode,
  };
};

const toggleThemeMode = () => (dispatch, getState) => {
  const currentMode = getState().config.themeMode;
  const newMode =
    currentMode === THEME_MODES.DARK ? THEME_MODES.LIGHT : THEME_MODES.DARK;
  persistThemeMode(newMode);
  dispatch(setThemeMode(newMode));
};

export {
  configReducer,
  setColor,
  setColorSidebar,
  setIsMinimized,
  setIsImage,
  setImage,
  setThemeMode,
  toggleThemeMode,
};
